import React from "react"
import autobind from "class-autobind"
import { Dialog, FlatButton } from "material-ui"
import strings from "../../../localization/strings"
import { IDate } from "../../../models"
import moment from "moment"
import * as reportAction from "../../../actions/ReportAction"
import DateRangeSelect from "../../../components/common/DateRangeSelect"

interface IProps {
    userId: string
    handleClose(): void
}
interface IState {
    // these datetime should be local time utc format
    startDate: IDate
    endDate: IDate
    errorDates: string
}

export default class UserDetailsRecordReportDialog extends React.Component<IProps, IState> {
    constructor(props) {
        super(props)
        const startDate = moment().add(-1, "month").add(1, "day").startOf("day").utc(true).format()
        const endDate = moment().endOf("day").utc(true).format()
        this.state = {
            startDate,
            endDate,
            errorDates: "",
        }
        autobind(this)
    }

    checkValidate() {
        let isValidate = true
        if (moment(this.state.startDate).isAfter(this.state.endDate)) {
            this.setState({ errorDates: strings.Invalid_date_range })
            isValidate = false
        }
        else {
            this.setState({ errorDates: "" })
        }
        return isValidate
    }

    handleRequestSave() {
        if (this.checkValidate()) {
            this.props.handleClose()
            reportAction.downloadUserRecordsData(this.props.userId, this.state.startDate, this.state.endDate)
        }
    }

    render() {
        return (
            <Dialog
                open
                title={strings.Employee_Record_Report}
                actions={[
                    <FlatButton data-intercom-target={"Employee-Report-Btn-CloseReportDialog"} key="cancel" label={strings.CANCEL} secondary onTouchTap={this.props.handleClose} />,
                    <FlatButton data-intercom-target={"Employee-Report-Btn-Report"} key="download" label={strings.Download} primary onTouchTap={this.handleRequestSave} />
                ]}
            >
                <DateRangeSelect
                    sameDatesAllowed
                    startDate={this.state.startDate}
                    endDate={this.state.endDate}
                    handleChange={(startDate, endDate) =>
                        this.setState({
                            startDate,
                            endDate
                        }, () => this.checkValidate())
                    }
                    errorEndDate={this.state.errorDates}
                />
            </Dialog>
        )
    }
}
